import React, { useEffect, useState } from 'react'
import '../css/home.css';
import philosophy from '../images/philosophy.jpg';
import modesty from '../images/modesty.jpg';
import teachers from '../images/teachers.jpg';
import team from '../images/team_2025.jpg';
import { Helmet } from 'react-helmet';
import { fetchContent, contentLines, contentText } from '../utils/siteContent';

const DEFAULT_EVENTS = [
    'PreSchool Open House - Monday, August 17th from 6 to 7:30.  Drop in @ The Studio',
    'PreSchool Begins - Tuesday, August 25th',
    'Fall Classes Begin Tuesday, September 8th. Monday classes will have a special makeup class on August 31st due to Labor Day Closure.',
    'Preschool Graduation - May 28th',
];

const DEFAULT_CLOSURES = [
    'Fall Break - October 15th thru October 19th',
    'Thanksgiving Break - November 25th thru November 27th',
    'Christmas Break - December 18th thru January 2nd',
    "Presidents' Day - February 12th thru February 13th",
    'Spring Break - April 5th thru April 10th',
    'Preschool Graduation - May 28th',
    'Memorial Day - May 31st',
];

const DEFAULT_PHILOSOPHY = [
    'One of our main goals is to foster a fun dance environment that is warm and supportive. Our instructors teach a full range of classes for ages 18 months to adult. We also offer several adult fitness and dance classes.',
    'Most dancers attend classes once a week to share in movement and their love of dance. For any dancer who has higher aspirations in mind, we have three competing teams.',
    '• Emerge Dance Company (ages 7 to 11)',
    '• Eclipse Dance Company (Skill Level)',
    '• Elite Dance Company (Skill Level up to age 18)',
    'We have dancers on teams at Vista Heights, Frontier, Westlake (Drill, Alliance, Dance, and Ballroom), Cedar Valley (Drill, Cheer and Dance) and Snow College. Dancers have also participated at BYU, UVU, Snow College and SALT choreography workshop and competition (1st place) in Salt Lake City.',
];

const DEFAULT_MODESTY = 'We carefully select music, costumes and choreography that are appropriate for a family community.';

const DEFAULT_TEACHERS = 'Our amazing instructors have danced professionally, studied dance in college or performed at the college level and have many years experience in teaching dancers of all ages.  Several have degrees and all of our teen teachers assisted in classes before teaching their own class.  We attend conferences, workshops, educational classes and reach out to others in our community for continued learning.';

export default function Home() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        fetchContent().then(setContent);
    }, []);

    const events = contentLines(content, 'home_events', DEFAULT_EVENTS);
    const closures = contentLines(content, 'home_closures', DEFAULT_CLOSURES);
    const philosophy_text = contentLines(content, 'home_philosophy', DEFAULT_PHILOSOPHY);
    const modesty_text = contentText(content, 'home_modesty', DEFAULT_MODESTY);
    const teachers_text = contentText(content, 'home_teachers', DEFAULT_TEACHERS);

    return (
        <div className="home-content">
            <Helmet>
                <title>In Motion Dance | Home</title>
            </Helmet>

            <div id="welcomeMsg">
                <h1 id="pageTitle">Welcome to In Motion Dance!</h1>
                <p className="home-badge">{contentText(content, 'home_badge', 'Always accepting Registrations')}</p>
            </div>
            <div className="welcomeImg">
                <img src={team} alt="team_picture" />
            </div>

            {/* These are the three 'zig-zag' cards: Philosophy, Modesty, and Teachers. */}
            <div className="home-card">
                <div className="home-row">
                    <div className="home-column-66">
                        <h2>Philosophy</h2>
                        {philosophy_text.map((line, i) => <p key={i}>{line}</p>)}
                    </div>
                    <div className="home-column-33">
                        <img src={philosophy} alt="philosophy_image" />
                    </div>
                </div>
            </div>
            <div className="home-card">
                <div className="home-row">
                    <div className="home-column-33">
                        <img src={modesty} alt="modesty_image" />
                    </div>
                    <div className="home-column-66">
                        <h2>Modesty</h2>
                        <p>{modesty_text}</p>
                    </div>
                </div>
            </div>
            <div className="home-card">
                <div className="home-row">
                    <div className="home-column-66">
                        <h2>Teachers</h2>
                        <p>{teachers_text}</p>
                    </div>
                    <div className="home-column-33">
                        <img src={teachers} alt="teachers_image" />
                    </div>
                </div>
            </div>

            {/* Events and Closures (side by side in large view, stacked on mobile) */}
            <div className="card-row">
                <div className="card-column">
                    <div className="card">
                        <h2>Events</h2>
                        <ul>
                            {events.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                </div>
                <div className="card-column">
                    <div className="card">
                        <h2>Closures</h2>
                        <p className="card-note">(Subject to change)</p>
                        <ul>
                            {closures.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    )
}
